import { PlusCircleOutlined, SaveOutlined } from '@ant-design/icons';
import { IconTrash } from '@tabler/icons-react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

interface ModalButtonsProps {
  onOk?: () => void;
  onCancel?: () => void;
  okText?: string;
  cancelText?: string;
  onDelete?: () => void;
}

export const ModalButtons = ({ onOk, onCancel, okText, cancelText, onDelete }: ModalButtonsProps) => {
  const { t } = useTranslation();

  return (
    <div className="modal-button-canceladd">
      {onCancel && (
        <Button shape="round" size="large" onClick={onCancel}>
          {cancelText || t('common.cancel')}
        </Button>
      )}
      {onOk && (
        <Button
          shape="round"
          size="large"
          type="primary"
          onClick={onOk}
          icon={okText === t('common.add') ? <PlusCircleOutlined /> : <SaveOutlined />}
        >
          {okText || t('common.add')}
        </Button>
      )}
      {onDelete && (
        <Button
          shape="round"
          size="large"
          onClick={(event) => {
            event.preventDefault();
            onDelete();
          }}
          icon={<IconTrash />}
        />
      )}
    </div>
  );
};
